<template>
  <div class="footer__item footer__item--second">
    <button class="no-out phone_item_link invisible-btn" @click="showPhoneModal">
      <svg
        class="icon"
        width="30px"
        height="25px"
        viewBox="0 0 40 40"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <title>Phone Icon</title>
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(3.000000, 3.000000)" stroke="#000000" stroke-width="2">
            <path
              d="M5.13245033,3 C8.08874172,4.51734752 11.784106,9.82806386 11.784106,9.82806386 C8.08874172,12.1040851 7.34966887,14.3801064 9.56688742,16.6561277 L17.6966887,25.0015391 C19.1748344,26.5188866 21.392053,25.0015391 23.6092715,21.2081703 C29.5218543,24.2428653 31,29.5535817 31,29.5535817 C24.3483444,38.6576668 18.4357616,34.1056242 15.4794702,31.829603 C12.5231788,29.5535817 3.21529536,19.5481921 0.698013245,14.3801064 C-2.25827815,8.31071633 5.13245033,3 5.13245033,3 Z"
            ></path>
            <path d="M16,7 C22.4285714,8.53846154 25.2857143,13.1538462 26,17" id="Stroke-3"></path>
            <path d="M18,0 C28.2857143,2.30769231 32.8571429,9.23076923 34,15" id="Stroke-5"></path>
          </g>
        </g>
      </svg>
      <h4 class="text">{{$t('callUs')}}</h4>
    </button>

    <transition name="fade">
      <div
        v-if="isOpen"
        class="footer__item__modal"
        id="phone"
        @mouseover="isHovering"
        @mouseleave="notHovering"
        v-on:blur="inputBlur"
      >
        <div class="mb5">
          <a class="link db" :href="`tel:${usCanadaNumber}`">
            <h2 class="title mt0 fw4">{{usCanadaNumber}}</h2>
            <p class="text ttu fw3 f6 mb3">({{$t('usCanTollFreeText')}})</p>
          </a>
        </div>
        <div class="mb5">
          <a class="link db" :href="`tel:${internationalNumber}`">
            <h2 class="title fw4">{{internationalNumber}}</h2>
            <p class="text ttu fw3 f6 mb1">({{$t('internationalPhoneNumberText')}})</p>
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { trackPageClick } from '@/utils/common';
export default {
  data() {
    return {
      phoneModalVisible: false,
      isOpen: false,
      hovering: false
    };
  },
  computed: {
    internationalNumber() {
      return this.$store.state.siteDetails.support_number_intl;
    },
    usCanadaNumber() {
      return this.$store.state.siteDetails.support_number_us_canada;
    }
  },
  methods: {
    trackPageClick,
    showPhoneModal() {
      this.isOpen = !this.isOpen;
    },
    inputBlur() {
      if (!this.hovering) {
        this.isOpen = false;
      }
    },
    isHovering() {
      this.hovering = true;
    },
    notHovering() {
      this.hovering = false;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
div.footer__item__modal#phone {
  position: relative;
  padding: 1rem;
  width: 267px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  border-top: 0px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  right: 65%;
  transform: translateX(50%);
  top: 25%;
  min-width: min-content;
  background-color: #eaeaea;
  height: auto;
  z-index: 1;
}

@media (max-width: 1023px) and (min-width: 860px) {
  div.footer__item__modal#phone {
    right: 50%;
    width: 100%;
    top: 14%;
  }
  div.mb5 {
    // width: 240px;
    width: 100%;
  }
}

@media (max-width: 860px) {
  div.footer__item__modal#phone {
    // right: 0%;
    position: static;
    display: block;
    margin: 0 auto;
    transform: translateX(0%);
    // width: 100%;
  }
  button.no-out.phone_item_link {
    display: block;
    margin: 0 auto;
  }
}
.mb5 {
  box-sizing: border-box;
  margin-bottom: 0px;
}
.link.db {
  text-align: center;
  color: #93cb53;
}

p.text.ttu {
  color: #333;
}

.phone_item_link {
  cursor: pointer;
  color: #93cb53;
}

.footer__item {
  text-align: center;
}
</style>
